module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Gb-Ha-Ia-Gd.589edb05.png";